module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTkyOCAxMjhhMzIgMzIgMCAwIDEgMzIgMzJ2NTc2YTMyIDMyIDAgMCAxLTMyIDMyaC0yNjAuNmw0OS41IDExNS40YTMyIDMyIDAgMCAxLTI5LjQgNDQuNkgzMzYuNWEzMiAzMiAwIDAgMS0yOS40LTQ0LjZMMzU2LjYgNzY4SDk2YTMyIDMyIDAgMCAxLTMyLTMyVjE2MGEzMiAzMiAwIDAgMSAzMi0zMmg4MzJ6IG0tMzIgNDQ4SDEyOHY5NmEzMiAzMiAwIDAgMCAyOC4zIDMxLjhMMTYwIDcwNGg3MDRhMzIgMzIgMCAwIDAgMzEuOC0yOC4zTDg5NiA2NzJ2LTk2eiIgZmlsbD0iIzAiIHAtaWQ9IjQzODIiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Computer-filled.svg
// module id = UQNC
// module chunks = 73